import { StreamResponseDataType } from "../FlowEditPage/utils/streamFetch";
import styles from "./index.less";
import { Divider, Modal } from "antd";
import WorkflowDebugList from "../WorkflowDebugList";

type DetailModalProps = {
  responseData: StreamResponseDataType[];
  onClose: () => void;
  open: boolean;
};
const DetailModal = ({ responseData, onClose, open }: DetailModalProps) => {
  return (
    <Modal
      open={open}
      footer={null}
      title="调试信息"
      rootClassName={styles["detail-modal"]}
      width={800}
      onCancel={onClose}
      destroyOnClose
    >
      <Divider style={{ margin: 0 }} />

      <WorkflowDebugList dataSource={responseData} />
    </Modal>
  );
};

export default DetailModal;
